import '@/assets/bc-icons/iconfont.css';
import '@mdi/font/css/materialdesignicons.css';
import 'babel-polyfill';
import Vue from 'vue';
import axios from 'axios'; // config [https://blog.csdn.net/weixin_33947521/article/details/91393630]
import Vueaxios from 'vue-axios';
// @ts-ignore
import Clipboard from 'v-clipboard';
import Echarts from 'echarts';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';
import { BcCommon } from './plugins/common';
import App from './App.vue';
// 控制台输出版本号，便于在 dist/nginx 环境下确认当前前端版本
console.log('%c 智联云设备平台 UI ', 'color: #0a7ea4; font-weight: bold; font-size: 12px;', `v${__APP_VERSION__}`, __APP_UPDATE_DATE__ ? `(${__APP_UPDATE_DATE__})` : '');
// import './registerServiceWorker';
require('es6-promise').polyfill();
Vue.prototype.$echarts = Echarts;
Vue.config.productionTip = false;
axios.defaults.timeout = 30000; // 响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; // 配置请求头
axios.defaults.headers = {
    // 解决IE下axios请求带缓存的问题 create by vacant at 2018-1-19
    // @ts-ignore
    Pragma: (!!window.ActiveXObject || 'ActiveXObject' in window) ? 'no-cache' : '',
};
axios.interceptors.request.use(
// @ts-ignore
(config) => {
    // console.log('check reouter token:', config, ',store:', store.state.token);
    if (store.state.token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
        // config.headers.Authorization = `token ${store.state.token}`
        // console.log('request1: ', config.headers.Authorization)
        Object.defineProperty(config, 'headers', Object.assign(config.headers, { Authorization: `token ${store.state.token}` }));
        // console.log('request2: ', config.headers.Authorization)
    }
    return config;
}, err => Promise.reject(err));
// http response 拦截器
axios.interceptors.response.use((response) => {
    const refreshToken = response.headers && response.headers.refresh_token;
    // 更新token
    if (refreshToken) {
        store.commit('setToken', refreshToken);
    }
    return response;
}, (error) => {
    if (error.response) {
        switch (error.response.status) {
            case 401:
                // 返回 401 清除token信息并跳转到登录页面
                store.commit('setSessionTimeout', true);
                store.commit('logout');
                if (router.currentRoute.name !== 'login') {
                    router.replace({
                        path: '/login',
                        query: { redirect: router.currentRoute.fullPath },
                    });
                }
                break;
            default:
                break;
        }
    }
    console.log('error on response:', error);
    return Promise.reject(error.response && error.response.data || '未知错误'); // 返回接口返回的错误信息
});
router.beforeEach((to, from, next) => {
    // 判断该路由是否需要登录权限
    const metaP = ((to.matched || []).filter((v) => v.meta && v.meta.requireAuth)[0]
        || { meta: to.meta });
    if (metaP && metaP.meta && metaP.meta.requireAuth) {
        try {
            store.commit('checkLogin');
            if (Object.keys(store.state.user || {}).length) {
                next();
            }
            else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath },
                });
            }
        }
        catch (e) {
            next({
                path: '/login',
                query: { redirect: to.fullPath },
            });
        }
    }
    else {
        next();
    }
});
// eslint-disable-next-line no-extend-native
Date.prototype.format = function (format) {
    const date = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'h+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3),
        'S+': this.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    Object.keys(date).forEach((k) => {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length));
        }
    });
    return format;
};
Vue.use(Vueaxios, axios);
Vue.use(Clipboard);
Vue.use(BcCommon);
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');
